<template>
<nav class="navbar is-default bottom">
  <div class="navbar-brand">
    <a class="navbar-item" href="/">
      <img src="../../static/logos/ooshzonelogo.png" alt="OOSH Zone Australia" width="auto" height="28">
    </a>
    <div @click="burgerMeth" id="burger" :class="{'navbar-burger burger ': true, 'is-active': burger }" data-target="trans">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>

  <div id="trans" :class="{'navbar-menu': true, 'is-active': burger }">
    <div class="navbar-start">
        <router-link class="navbar-item is-primary active" to="/">
        Home
        </router-link>
        <router-link class="navbar-item is-primary" to="/about">
        About
        </router-link>
        <router-link class="navbar-item is-primary" to="/documents">
        Documents
        </router-link>
        <router-link class="navbar-item is-primary" to="/gallery">
        Gallery
        </router-link>
        <router-link class="navbar-item is-primary" to="/contact">
        Contact
        </router-link>
        <router-link class="navbar-item is-primary enrol" to="/enrol">
        <strong>ENROL NOW</strong>
        </router-link>
    </div>
    <div class="navbar-end">
      <!-- <div class="navbar-item no-pad-right">
        <p class="has-text-bolder">Choose your center:
        </p>
      </div> -->
      <div class="navbar-item">
        <div class="field has-addons margin-auto">
          <p class="control">
            <a @click="changeSchool('stgregs')"  :class="{'button': true, 'active': school === 'stgregs' }">
              <span>St Greg's</span>
            </a>
          </p>
          <p class="control">
              <a @click="changeSchool('maryimmaculate')" :class="{'button': true, 'active': school === 'maryimmaculate' }">
                <span>Mary Immaculate</span>
              </a>
            </p>
        </div>
      </div>
    </div>
      <!-- <div class="navbar-item">
        <strong>OOSH Zone Australia</strong>
      </div> -->
  </div>
</nav>
</template>

<script>
export default {
  name: 'Navbar',
  props: ['school', 'changeSchooll'],
  data () {
    return {
      msg: '',
      active: '/',
      transitionName: 'fade',
      burger: false
    }
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function (value) {
      // console.log(this.active + ' x ' + value.name)
      this.active = value.name
      this.burger = false
      // console.log(this.active + ' x ' + value.name)
    },
    checkActive: function (value) {
      console.log(value)
      return value === this.active
    },
    burgerMeth: function () {
      this.burger = !this.burger
    },
    changeSchool: function (newSchool) {
      this.changeSchooll(newSchool)
      this.burger = false
    }
    // },
    // watch: {
    //   '$route' (to, from) {
    //     const toDepth = to.path.split('/').length
    //     const fromDepth = from.path.split('/').length
    //     this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    //   }
    // }
  }
}
</script>

<style scoped>
nav.navbar {
  position: fixed; /* Set the navbar to fixed position */
  top: 0; /* Position the navbar at the top of the page */
  width: 100%; /* Full width */
  z-index: 32;
}
a {
  color: black;
}
.bottom {
  background: #e67e22;
}
.enrol {
  background-color: #e67d22b6;
}
.navbar-brand,
.navbar-menu,
.navbar-burger {
  min-height: 60px;
}
a.navbar-item {
  color: #111;
}
a.navbar-item:hover {
   background: #fff;
 }
.navbar-brand .navbar-item {
  background: #fff;
}

a.button {
  /* background: #111; */
  color: #111;
}

a.button.active {
  background: #111;
  color: #e67e22;
  border: 1px solid #111;
  font-weight: 600;
}
.margin-auto {
  justify-content: center;
}
.has-text-bolder {
  font-weight: 600;
  color:#111;
}
.no-pad-right {
  padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue